import React from 'react';


const DEFAULT_SRC = 'https://www.timberblock.com/wp-content/uploads/default-placeholder.png';


const ImageFrame = ({ src }) => {
  return (
    <img 
      className="ui centered image" 
      src={src || DEFAULT_SRC}
      width={150}
      height={150}
      alt="" 
    />
  );
}


export default ImageFrame;
